/**
 * Code has been mostly copied from:
 *
 * - https://github.com/fahad19/tydel/tree/master/test/types
 */
import { chain } from "./chainType";
import { TypesError } from "./errors";
function isPlainObject(v) {
    // @TODO: make it bullet proof
    return v !== null && typeof v === "object" && v.constructor === Object;
}
function mapValues(object, mapFn) {
    return Object.keys(object).reduce(function (result, key) {
        var value = mapFn(object[key], key);
        if (value !== undefined) {
            result[key] = value;
        }
        return result;
    }, {});
}
export var Types = {};
Types.string = chain(function (value) {
    if (typeof value === "undefined") {
        return value;
    }
    if (typeof value !== "string") {
        throw new TypesError("value is not a string");
    }
    return value;
});
Types.bool = chain(function (value) {
    if (typeof value === "undefined") {
        return value;
    }
    if (typeof value !== "boolean") {
        throw new TypesError("value is not a boolean");
    }
    return value;
});
Types.number = chain(function (value) {
    if (typeof value === "undefined") {
        return value;
    }
    if (typeof value !== "number") {
        throw new TypesError("value is not a number");
    }
    return value;
});
Types.array = chain(function (value) {
    if (typeof value === "undefined") {
        return value;
    }
    if (!Array.isArray(value)) {
        throw new TypesError("value is not an array");
    }
    return value;
});
Types.array.of = function (schema) {
    return chain(function (value) {
        if (typeof value === "undefined") {
            return value;
        }
        if (!Array.isArray(value)) {
            throw new TypesError("value is not an array");
        }
        return value.map(function (item) { return schema(item); });
    });
};
Types.enum = function (enums) {
    if (enums === void 0) { enums = []; }
    if (!Array.isArray(enums)) {
        enums = [enums];
    }
    return chain(function (value) {
        if (typeof value === "undefined") {
            return value;
        }
        var isValid = enums.some(function (enumValue) {
            return value === enumValue;
        });
        if (isValid) {
            return value;
        }
        throw new TypesError("value is none of the provided enums");
    });
};
Types.object = chain(function (value) {
    if (typeof value === "undefined") {
        return value;
    }
    if (!isPlainObject(value)) {
        throw new TypesError("value is not an object");
    }
    return value;
});
function validateAndReturnObject(value, schema) {
    return mapValues(schema, function (type, k) {
        try {
            return type(value[k]);
        }
        catch (e) {
            throw new TypesError("schema failed for key '" + k + "', " + e.message);
        }
    });
}
Types.object.of = function (schema) {
    if (!isPlainObject(schema)) {
        throw new TypesError("`object.of` must receive a plain object");
    }
    return chain(function (value) {
        if (typeof value === "undefined") {
            return value;
        }
        if (!isPlainObject(value)) {
            throw new TypesError("value is not an object");
        }
        return validateAndReturnObject(value, schema);
    });
};
Types.const = function (expectedValue) {
    return chain(function (value) {
        if (typeof value === "undefined") {
            return value;
        }
        if (value !== expectedValue) {
            throw new TypesError("value did not equal " + expectedValue);
        }
        return value;
    });
};
//# sourceMappingURL=index.js.map